module.exports = __webpack_public_path__ + "static/img/capital_meter.5166a2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/capital_meter.png
// module id = H2VC
// module chunks = 1